import { OptionString } from "../../../interfaces/interfaces";
import { TFunction } from "i18next";
import { MenuItemFormData } from "./DishUpdatePage";

export const getCookingTimeOptions = (t: TFunction): OptionString[] => [
    {
        value: "5-10",
        label: `5-10 ${t("min")}`,
    },
    {
        value: "10-20",
        label: `10-20 ${t("min")}`,
    },
    {
        value: "20-30",
        label: `20-30 ${t("min")}`,
    },
    {
        value: "30-45",
        label: `30-45 ${t("min")}`,
    },
    {
        value: "45-60",
        label: `45-60 ${t("min")}`,
    },
    {
        value: "1hour",
        label: t("more one hour"),
    },
];
export const getEmptyMenuItemForm = (t: TFunction): MenuItemFormData => ({
    name: "",
    types: [],
    categories: [],
    description: "",
    composition: "",
    unit: null,
    portions: [
        {
            name: t("Standard portion"),
            volume: null,
            price: null,
        },
    ],
    cookingTime: "",
    isLongCookingTime: false,
    markers: [],
    allergens: [],
    supplements: [],
    image: null,
    isUpdateImage: false,
    deleted: false,
});
